import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    field: String,
    value: String
  }

  connect() {
    this.originalValue = this.valueValue
    this.isEditing = false
  }

  click(event) {
    if (!this.isEditing) {
      event.preventDefault()
      this.startEditing()
    }
  }

  startEditing() {
    this.isEditing = true
    this.originalHTML = this.element.innerHTML

    const input = document.createElement('input')
    input.type = this.fieldValue === 'unit_price' ? 'number' : 'number'
    input.step = this.fieldValue === 'unit_price' ? '0.01' : '1'
    input.value = this.valueValue
    input.className = 'form-control form-control-sm'
    input.style.minWidth = '120px'
    input.style.width = '100%'

    input.addEventListener('blur', () => this.save(input))
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        this.save(input)
      } else if (e.key === 'Escape') {
        e.preventDefault()
        this.cancel()
      }
    })

    this.element.innerHTML = ''
    this.element.appendChild(input)
    input.focus()
    input.select()
  }

  async save(input) {
    const newValue = input.value

    if (newValue === this.valueValue) {
      this.cancel()
      return
    }

    // Prepare form data
    const formData = new FormData()
    formData.append('_method', 'patch')
    formData.append(`tax_quote_line_item[${this.fieldValue}]`, newValue)

    // Get CSRF token
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': token,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: formData
      })

      if (response.ok) {
        // Get the Turbo Stream response and let Turbo process it
        const html = await response.text()
        Turbo.renderStreamMessage(html)
        
        this.valueValue = newValue
        this.isEditing = false
      } else {
        console.error('Failed to update line item')
        this.cancel()
      }
    } catch (error) {
      console.error('Error updating line item:', error)
      this.cancel()
    }
  }

  cancel() {
    this.element.innerHTML = this.originalHTML
    this.isEditing = false
  }
}
